import urls from "../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../utils/service";

export async function getCountry() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETCOUNTRY, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllUsers() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getState(countryId: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETSTATEBYCOUNTRYID + countryId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getCity(stateId: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETCITYBYSTATEID + stateId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getTimeZone(countryId: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETTIMEZONEBYCOUNTRYID + countryId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getTask(id: any) {
  
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTASK}${id}`, callParams);
    console.log(id,response,"reminderResponseData")
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addTask(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDTASK, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
